module.exports = __webpack_public_path__ + "img/sozialschnellgut_8_b.ba119153.jpg";